/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var JewelCrownIcon16Solid = forwardRef('JewelCrownIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8.64 1.738a.778.778 0 0 0-1.28 0L5.224 4.83 2.239 2.627a.778.778 0 0 0-1.231.74l.905 6.083c.133.89.896 1.548 1.795 1.548h8.584c.899 0 1.662-.658 1.795-1.548l.905-6.083a.778.778 0 0 0-1.231-.74L10.777 4.83 8.64 1.738Z" }),
        React.createElement("path", { d: "M3 12a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2H3Z" })));
});
